import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // 引入路由配置
 
const app = createApp(App);
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
// 导入语言文件
import { createHead } from '@vueuse/head';
const head = createHead();
 


app.use(head);
app.use(router); // 注册路由
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
app.mount('#app');
 
